export default "__VITE_ASSET__2cb311a8__"